/** Журнал входов и выходов (GET /admin/users/{user}/auth-events, схема AuthEvent в OpenAPI API) */

export const AUTH_EVENT_TYPES = [
  'login_ok',
  'login_failed',
  'refresh_ok',
  'refresh_failed',
  'logout',
  'token_rejected',
  'tokens_invalidated',
  'client_forced_logout',
] as const

export type AuthEventType = (typeof AUTH_EVENT_TYPES)[number]

export interface AuthEvent {
  id: number
  /** null — токена не было или подпись не сошлась */
  user_id: number | null
  event: AuthEventType
  /** Серверная причина (AuthEventReason) или, у client_forced_logout, причина клиента */
  reason: string | null
  /** Вход, с которого идёт сессия (iat токена) */
  session_iat: string | null
  /** Отпечаток токена события (16 символов sha256 от jti) */
  jti_hash: string | null
  /** Отпечаток токена, из которого получен токен события */
  parent_jti_hash: string | null
  /** Сколько секунд назад токен события занесли в чёрный список */
  blacklisted_ago_s: number | null
  ip: string | null
  user_agent: string | null
  client: string | null
  client_version: string | null
  tab_id: string | null
  prior_state: string | null
  created_at: string
}

export interface AuthEventsMeta {
  current_page: number
  last_page: number
  per_page: number
  total: number
}

export interface AuthEventsPage {
  data: AuthEvent[]
  meta: AuthEventsMeta
}

export interface AuthEventsQuery {
  event?: AuthEventType
  page?: number
  per_page?: number
}
